import { combineReducers } from 'redux';
import { reducer as oidc } from 'redux-oidc';
import auth from './authReducer';
import errors from './errorsReducer';
import gridFilters from './gridFiltersReducer';

const uiElements = combineReducers({
  auth,
  oidc,
  errors,
  gridFilters,
});

export default uiElements;
